
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clm/certius-ai",
      function () {
        return require("private-next-pages/clm/certius-ai/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clm/certius-ai"])
      });
    }
  